__turbopack_context__.v({
  "emptyResult": "CqxKWq_emptyResult",
  "projects": "CqxKWq_projects",
  "root": "CqxKWq_root",
  "searchBar": "CqxKWq_searchBar",
  "searchInput": "CqxKWq_searchInput",
  "title": "CqxKWq_title",
});
